import router from '@/router'; // 导入路由对象
import { gzhCodeGetOpenId, appIdLogin } from '@/api/user'
import { getHomeOrderList } from "@/api/aiJia";
const state = {
  userInfo: '',
  mineInfo: {},
  code: '',
  openId: '',
  // 登录后的重定向地址
  // reUrl: '/aj/index',
  reUrl: '/index',
  payOrderList:[]
};

function getUrlName(paramName) {
  const url = window.location.href;
  const regex = new RegExp(`${paramName}=([^&]*)`);
  const match = regex.exec(url);
  if (match) {
    return match[1];
  } else {
    return null;
  }
}

function deUrlParam(url, params) {
  for (let index = 0; index < params.length; index++) {
    let item = params[index];
    let fromIndex = url.indexOf(`${item}=`); // 必须加=号，避免参数值中包含item字符串
    if (fromIndex !== -1) {
      let startIndex = url.indexOf("=", fromIndex);
      let endIndex = url.indexOf("&", fromIndex);
      let hashIndex = url.indexOf("#", fromIndex);

      let reg = "";
      if (endIndex !== -1) {
        let num = endIndex - startIndex;
        reg = new RegExp(`${item}=.{${num}}`);
        url = url.replace(reg, "");
      } else if (hashIndex !== -1) {
        let num = hashIndex - startIndex - 1;
        reg = new RegExp(`&?${item}=.{${num}}`);
        url = url.replace(reg, "");
      } else {
        reg = new RegExp(`&?${item}=.+`);
        url = url.replace(reg, "");
      }
    }
  }
  let noSearchParam = url.indexOf("=");
  if (noSearchParam === -1) {
    url = url.replace(/\?/, ""); // 如果已经没有参数，删除？号
  }
  return url;
}
const mutations = {
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_MINE_INFO: (state, mineInfo) => {
    state.mineInfo = mineInfo;
  },
  SET_CODE: (state, code) => {
    state.code = code;
  },
  SET_OPENID: (state, e) => {
    state.openId = e;
  },
  SET_payOrderList: (state, e) => {
    state.payOrderList = e;
  }
};

const actions = {
  isLogin({state}) {
    if (state.userInfo === '') {
      return false
    } else {
      return true
    }
  },
  async logout({ commit }) {
    try {
      commit('config/SET_tabActive', 0, { root: true }); // 使用 root 选项
      commit('config/sendAJAcive', 0, { root: true }); // 使用 root 选项
      localStorage.removeItem('token'); // 清除token
      sessionStorage.clear(); // 清除session
    } catch (error) {
      console.error('Error while clearing local storage:', error);
    }
    await router.push('/');
  },
  OpenKefu() {
    window.location.href = "https://work.weixin.qq.com/kfid/kfc3da1bd822aefcbe5";
  },

async getOpenId({ commit, state, dispatch }, providedUrl) {
  var isPerMisser = true; // 根据你的逻辑调整这个值
  if (!isPerMisser) {
    return;
  }
  const currentPath = router.currentRoute.fullPath || ''; // 获取当前路由路径
  var urla = providedUrl || '';
  let REDIRECT_URI = ''; // 使用 let 而不是 const
  if (!urla) {
    REDIRECT_URI = encodeURIComponent('http://yax-h5.bjyxinfo.com/#/aj/index');
    // state.reUrl='/aj/index'
    state.reUrl='/index'
  } else {
    REDIRECT_URI = encodeURIComponent(urla);
    state.reUrl='/aj/gzhpayList'
  }
    const APPID = 'wxc7e8b694c333b5f0';
    const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    console.log(currentPath);
    if (window.location.href.indexOf('code=') !== -1) { // 避免一直重复重定向无限获取code
      let code = getUrlName('code'); // 从url中获取code的值
      if (code === state.code) { // 微信获取code会重定向，所以从别的页面返回本页后，返回的其实是重定向之后的url,此时url一定带有上次的code,code只能用一次，这时候要重新获取
        let urls = deUrlParam(window.location.href, ['code']); // 从url中删除code
        window.location.href = urls;
        return;
        }
        var reqData = {
            code:code
        }
        gzhCodeGetOpenId(reqData).then(res => {
            if (res.data.state === 0) {
                var e= res.data.data
              commit('SET_OPENID', e);
              var param = {
                appId:e
              }
              appIdLogin(param).then(a => {
                if (a.data.state === 0) {
                  //拿用户的支付列表
                  var c = {
                       yaxUserId: a.data.data.yaxUserId,
                  }
                  getHomeOrderList(c).then(d => {
                    if (d.data.state === 0) {
                      var payOrderList = d.data.data.orderList
                         commit('SET_payOrderList', payOrderList);
                    } else {
                         commit('SET_payOrderList', []);
                    }
                  })
                  commit('SET_USER_INFO', a.data.data)
                } else {
                 dispatch('logout');
                }
              })
            }
        })
      commit('SET_CODE', code);
    } else {
      window.location.href = url;
    }
      }

};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
